<template>
    <div class="fullheight">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item" style="padding-top: 10px">
              <img
                src="../../src/assets/img/cardiff-white-text-only.png"
                id="logo"
                height="28"
              />
            </a>
          </div>
        </div>
      </nav>
      <div class="container is-fluid fullheight" id="appcontainer">
        <div class="columns fullheight is-centered">
          <div class="column" id="app-column">
            <transition name="slide" mode="out-in">
              <VerifyOpportunityLoading
                v-if="page == 0"
                key="p0"
                @next="incrementPage"
                @doublenext="page += 2"
                :link="$route.params.sfOpportunityId"
              />
              <BankVerify
                v-if="page == 1"
                key="p1"
                @next="incrementPage"
                message="To speed up the funding process, we use bank verification to automatically process your loan. You'll be asked to select your bank and enter your online banking credentials through our secure portal.<br><br>Please use your <strong>business bank account</strong>, personal accounts are not accepted."
              />
              <Plaid
                v-if="page == 2"
                key="p2"
                @next="incrementPage"
                api="connect-bank-opportunity"
                :link="$route.params.sfOpportunityId"
                redirect_url="connect-bank-opportunity"
              />
              <VerifyFinish
                v-if="page == 3"
                key="p3"
                @next="incrementPage"
                :result="finresult"
              />
            </transition>
          </div>
        </div>
      </div>
      <footer class="footer" style="margin-top: 60px" v-if="page != 7">
        <div class="content has-text-centered">
          <img
            src="../../src/assets/img/bbb.svg"
            style="margin-left: 15px; max-width: 120px"
          />
          <img
            src="../../src/assets/img/ssl.svg"
            style="margin-left: 15px; max-width: 120px; margin-right: 15px"
          />
          <p style="font-size: 0.675em; color: grey; margin-top: 10px">
            © 2024 Cardiff, Inc
          </p>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import {
    VerifyOpportunityLoading,
    BankVerify,
    Plaid,
    VerifyFinish,
  } from "@/components/apply/pages";
  import { build } from "@/tools/modelBuilder";
  export default {
    name: "ConnectBankOpportunity",
    components: {
      BankVerify,
      Plaid,
      VerifyFinish,
      VerifyOpportunityLoading,
    },
    data() {
      return {
        page: 0,
        demo: false,
        customerId: null,
        model: { name: "", sfopportunityID: null },
        finresult: false,
        plaid_result: ''
      };
    },
    methods: {
      incrementPage: function (pageData) {
        console.log(pageData);
        this.validate();
        build(this.model, pageData);
        // if (pageData.customerId) {
        //   console.log("we have the customer id ", pageData.customerId);
        //   this.customerId = pageData.customerId;
        // }
        if (pageData.plaid_result) {
            this.plaid_result = pageData.plaid_result;
        }
        if (pageData.item_id) {
            this.item_id = pageData.item_id;
            self.plaid = {
                item_id: pageData.item_id,
                access_token: pageData.access_token,
            };
            this.finresult = true;
            $.ajax({
            type: "POST",
            url: "/api/connect-bank-opportunity/completed_plaid",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                model: self.model,
            }),
            })
            .done(function (response) {
                console.log(response);
                //   if (response.leadid) {
                //     console.log("setting leadid in model", response.leadid);
                //     self.model.sfleadid = response.leadid;
                //     //save to local storage
                //     setWithExpiry("leadid", response.leadid, 259200);
                //   }
            })
            .fail(function (err) {
                console.log(err.responseText);
                // self.invalid = true;
            });  
        }
        this.page++;
        window.scrollTo(0, 0);
      },
      validate: function () {
        console.log(this.$route.params.sfOpportunityId);
      },
    },
    mounted: function () {
      if (!this.demo) {
        return;
      }
      const self = this;
      if (
      self.$route.params &&
      self.$route.params.sfOpportunityId &&
      self.$route.params.sfOpportunityId != "oauth"
    ) {
        setWithExpiry("oauth_state_id", "", 10);
        setWithExpiry("opportunityID", self.$route.params.sfOpportunityId, 259200);
    }

    const opportunityID = getWithExpiry("opportunityID");
    
    if (
      self.$route.query &&
      self.$route.query.oauth_state_id &&
      self.$route.query.oauth_state_id !== ""
    ) {
      setWithExpiry("oauth_state_id", self.$route.query.oauth_state_id, 259200);
    }

    if (opportunityID) {
      self.model.sfopportunityID = opportunityID;
    }
    let oauth_token = getWithExpiry("oauth_state_id");
    console.log("oauth token:" + oauth_token);
    if (oauth_token && oauth_token !== "") {
      console.log("found oauth token! ");
      //when we have oauth token the user came from a redirection from the bank website
      self.page = 2;
    }
      
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .navbar {
    background-color: #3c5cac;
    z-index: 2;
  }
  .navbar .navbar-brand {
    text-align: center;
    display: block;
    width: 100%;
  }
  
  .navbar .navbar-brand > .navbar-item,
  .navbar .navbar-brand .navbar-link {
    display: inline-block;
  }
  @media screen and (min-width: 767px), print {
    .mobile-only {
      display: none;
    }
    .fullheight {
      height: 100%;
    }
    #app-column {
      padding: 50px 120px;
    }
  }
  
  @media screen and (max-width: 768px) {
    #cardiff-column {
      display: none;
    }
    #app-column {
      min-height: 100vh;
      padding-top: 50px;
    }
  }
  
  #cardiff-column {
    background: #f1f1f1;
    z-index: 1;
    padding-top: 100px;
    max-width: 280px;
  }
  
  #logo {
    /* max-width: 50%; */
    margin: auto;
    display: block;
    /* margin-top: 10px; */
    /* margin-bottom: 10px; */
  }
  
  .next-button {
    margin-top: 10px;
  }
  
  .columns {
    margin-left: 0;
    margin-right: 0;
  }
  
  .no-margin {
    margin-bottom: 0px !important;
  }
  </style>
  